import {AfterContentChecked, Component, ElementRef, EventEmitter, Input, Output, ViewChild,} from '@angular/core'
import dayjs from 'dayjs';
import {defineLocale} from 'ngx-bootstrap/chronos'
import {BsDatepickerModule, BsLocaleService} from 'ngx-bootstrap/datepicker'
import {frLocale} from 'ngx-bootstrap/locale'
import {NiceCheckboxComponent} from '../nice-checkbox/nice-checkbox.component'
import {NgClass, NgIf} from '@angular/common'

defineLocale('fr', frLocale) // for datepicker

@Component({
    selector: 'app-action-button',
    templateUrl: './action-button.component.html',
    styleUrls: ['./action-button.component.scss'],
    imports: [NgIf, NgClass, NiceCheckboxComponent, BsDatepickerModule]
})
export class ActionButtonComponent implements AfterContentChecked {
    @Input() data: any = undefined
    @Output() actionButtonEventEmitted = new EventEmitter<any>()
    @ViewChild('dp', { static: false }) dp!: ElementRef
    public locale: string = 'fr'
    public minDateDatePicker!: Date
    public maxDateDatePicker!: Date

    public dateError!: boolean
    public datePickerIsDisabled: boolean = true
    public dateValue!: Date | null

    constructor(private localeService: BsLocaleService) {
        // Language used for datepicker :
        this.localeService.use(this.locale)
        // Date min = 1e jour du mois en cours.
        /*this.minDateDatePicker = moment().startOf('month').toDate()*/
        this.minDateDatePicker = dayjs().startOf('month').toDate();

        // limite du choix à 40 jours  arrondi fin de mois dans le futur
        this.maxDateDatePicker = dayjs().add(40, 'day').endOf('month').toDate();
        /*this.maxDateDatePicker = moment().add(40, 'days').endOf('month').toDate()*/
    }

    ngAfterContentChecked(): void {
        if (this.data.action === 'datePickerDate') {
            this.datePickerIsDisabled = false
            this.dateValue = this.data.actionFieldValue
                ? dayjs(this.data.actionFieldValue, 'MM-DD-YYYY').toDate() /*moment(this.data.actionFieldValue, 'DD/MM/YYYY').toDate()*/
                : null
        }
    }

    public clickButton() {
        this.actionButtonEventEmitted.emit(this.data)
    }

    /**
     * return updated object to parent after changing checkbox value.
     */
    public clickCheckBox(event: any) {
        this.data.actionFieldValue = event.target.checked
        this.actionButtonEventEmitted.emit(this.data)
    }

    /**
     * return object with datePicker's selected date
     * @param event : date selected (Date)
     */
    public sendSelectedDate(event: any) {
        const date = dayjs(event,'DD/MM/YYYY');
        const minDate = dayjs(this.minDateDatePicker,'DD/MM/YYYY');
        if (date.isValid() && date.isSameOrAfter(minDate) && date.isSameOrBefore(this.maxDateDatePicker)) {
            this.dateError = false
            this.data.actionFieldValue = date
            this.data.error = undefined
            this.actionButtonEventEmitted.emit(this.data)
        } else {
            this.dateError = true
            if (!date.isValid()) {
                this.data.error = {
                    status: 'INVALID_DATE',
                    label: 'Mauvais format du champ date',
                }
            }
            if (!date.isSameOrAfter(minDate)) {
                this.data.error = {
                    status: 'INVALID_DATE',
                    label: `Date inférieure à la date minimum possible (${dayjs(this.minDateDatePicker).format('DD/MM/YYYY')})`,
                }
            }
            if (!date.isSameOrBefore(this.maxDateDatePicker)) {
                this.data.error = {
                    status: 'INVALID_DATE',
                    label: `Date supérieure à la date maximum possible (${dayjs(this.maxDateDatePicker).format('DD/MM/YYYY')})`,
                }
            }
            this.actionButtonEventEmitted.emit(this.data)
        }
    }

    openDatepicker() {
        this.dp.nativeElement.click()
    }
}
